import { useAtomValue, useSetAtom } from "jotai";
import {
  DeductionsByPurchaserState,
  DeductionsByTypeAndReasonState,
  DeductionVolumeVsGrossSalesState,
  DeductionsByAgingBracketsState,
  DisputePipelineState,
  DeductionsByRetailerState,
  deductionsByPurchaserAtom,
  deductionsByTypeAndReasonAtom,
  deductionVolumeVsGrossSalesAtom,
  deductionsByAgingBracketsAtom,
  disputePipelineAtom,
  deductionsByRetailerAtom,
  fetchDeductionsByPurchaserAtom,
  fetchDeductionsByTypeAndReasonAtom,
  fetchDeductionVolumeVsGrossSalesAtom,
  fetchDeductionsByAgingBracketsAtom,
  fetchDisputePipelineAtom,
  fetchDeductionsByRetailerAtom,
} from "@/store/analytics";

interface UseAnalyticsKPI {
  deductionsByPurchaser: DeductionsByPurchaserState;
  fetchDeductionsByPurchaser: () => void;
  deductionsByTypeAndReason: DeductionsByTypeAndReasonState;
  fetchDeductionsByTypeAndReason: () => void;
  deductionVolumeVsGrossSales: DeductionVolumeVsGrossSalesState;
  fetchDeductionVolumeVsGrossSales: () => void;
  deductionsByAgingBrackets: DeductionsByAgingBracketsState;
  fetchDeductionsByAgingBrackets: () => void;
  disputePipeline: DisputePipelineState;
  fetchDisputePipeline: () => void;
  deductionsByRetailer: DeductionsByRetailerState;
  fetchDeductionsByRetailer: () => void;
}

export const useAnalyticsKPI = (): UseAnalyticsKPI => {
  const deductionsByPurchaser = useAtomValue(deductionsByPurchaserAtom);
  const deductionsByTypeAndReason = useAtomValue(deductionsByTypeAndReasonAtom);
  const deductionVolumeVsGrossSales = useAtomValue(deductionVolumeVsGrossSalesAtom);
  const deductionsByAgingBrackets = useAtomValue(deductionsByAgingBracketsAtom);
  const disputePipeline = useAtomValue(disputePipelineAtom);
  const deductionsByRetailer = useAtomValue(deductionsByRetailerAtom);
  const fetchDeductionsByPurchaser = useSetAtom(fetchDeductionsByPurchaserAtom);
  const fetchDeductionsByTypeAndReason = useSetAtom(fetchDeductionsByTypeAndReasonAtom);
  const fetchDeductionVolumeVsGrossSales = useSetAtom(fetchDeductionVolumeVsGrossSalesAtom);
  const fetchDeductionsByAgingBrackets = useSetAtom(fetchDeductionsByAgingBracketsAtom);
  const fetchDisputePipeline = useSetAtom(fetchDisputePipelineAtom);
  const fetchDeductionsByRetailer = useSetAtom(fetchDeductionsByRetailerAtom);

  return {
    deductionsByPurchaser,
    fetchDeductionsByPurchaser,
    deductionsByTypeAndReason,
    fetchDeductionsByTypeAndReason,
    deductionVolumeVsGrossSales,
    fetchDeductionVolumeVsGrossSales,
    deductionsByAgingBrackets,
    fetchDeductionsByAgingBrackets,
    disputePipeline,
    fetchDisputePipeline,
    deductionsByRetailer,
    fetchDeductionsByRetailer,
  };
};
